const getOptions = (countryData, countryId, label) => {
    const getTerritories = (country) =>
        country.stateProvinces.map((stateProvince) => ({
            country: `\u2014 ${country.countryName} \u2014`,
            value: stateProvince.id,
            label: stateProvince.stateProvinceName,
            key: stateProvince.id,
        }));

    const countriesWithTerritories = countryData
        .filter((c) => c.stateProvinces.length > 0)
        .reduce((acc, country) => {
            return {
                ...acc,
                [country.id]: country,
            };
        }, {});

    const defaultOption = { value: '', label, key: 'all' };

    // A country is selected without states or provinces
    if (countryId && !countriesWithTerritories[countryId]) {
        return [defaultOption];
    }

    // A country is selected with states or provinces
    if (countryId && countriesWithTerritories[countryId]) {
        return [defaultOption, ...getTerritories(countriesWithTerritories[countryId])];
    }

    const options = [defaultOption];
    Object.keys(countriesWithTerritories).forEach((countryCode) => {
        const country = countriesWithTerritories[countryCode];
        options.push(...getTerritories(country));
    });

    return options;
};

const diffStatesAndProvinces = (current, next) => {
    const areStatesDiff =
        next.states.length !== current.states.length || next.states.every((state) => current.states.includes(state));

    const areProvincesDiff =
        next.provinces.length !== current.provinces.length ||
        next.provinces.every((province) => current.provinces.includes(province));

    return areStatesDiff || areProvincesDiff;
};

export default {
    getOptions,
    diffStatesAndProvinces,
};
